<div class="app-list">
  <h1 class="app-list__title">All Applications</h1>

  <div class="app-list__filter">
    <mat-icon>filter_alt</mat-icon>
    <claas-toggle
      [checked]="store.onlyFavorites()"
      [label]="'only favorites'"
      (checkedChange)="setOnlyFavorites($event)"
    />
  </div>

  @if (store.status() === "loading") {
    @for (cat of [0, 1]; track cat) {
      <section class="app-list__category">
        <claas-skeleton variant="text" width="140px" height="28px" />
        <div class="app-list__grid app-list__grid--skeleton">
          @for (card of [0, 1, 2]; track card) {
            <div class="app-card-skeleton">
              <div class="app-card-skeleton__favorite">
                <claas-skeleton variant="circular" width="28px" height="28px" />
              </div>
              <div class="app-card-skeleton__content">
                <claas-skeleton variant="circular" width="60px" height="60px" />
                <div class="app-card-skeleton__title">
                  <claas-skeleton variant="text" width="70%" height="20px" />
                  <claas-skeleton variant="text" width="50%" height="20px" />
                </div>
              </div>
              <div class="app-card-skeleton__actions">
                <claas-skeleton variant="text" width="64px" height="20px" />
                <claas-skeleton
                  variant="rectangular"
                  width="88px"
                  height="30px"
                />
              </div>
            </div>
          }
        </div>
      </section>
    }
  }
  @if (store.status() === "error") {
    <p class="app-list__state app-list__state--error">
      Failed to load applications.
    </p>
  }
  @if (store.status() === "ready") {
    @if (store.filteredCategories().length === 0) {
      <p class="app-list__state">No applications found.</p>
    }
    @for (category of store.filteredCategories(); track category.id) {
      <section class="app-list__category">
        <h2 class="app-list__category-title">{{ category.name }}</h2>
        <div class="app-list__grid">
          @for (app of category.applications; track app.id) {
            <app-application-card
              [app]="app"
              [isFavorite]="store.favoriteIds().has(app.id)"
              (favoriteToggled)="toggleFavorite($event)"
            />
          }
        </div>
      </section>
    }
  }
</div>
